// src/shared/changelog/components/ChangelogShell.tsx
import React from "react";
import GenericCard from "@ui-components/Card/GenericCard";

interface ChangelogShellProps {
  /** Fixed header area (title, back button…). */
  header: React.ReactNode;
  /** Optional fixed toolbar (filters). */
  toolbar?: React.ReactNode;
  /** Scrollable content. */
  children: React.ReactNode;
}

/**
 * Shared layout for the changelog pages: a viewport-bounded `GenericCard` in
 * fill-height mode (`flex`/`h-full` flips its body to `flex flex-1 min-h-0
 * flex-col`, dropping the `max-h` clamp) so the header + toolbar stay fixed
 * and only the content area scrolls. Used by both the versions list and the
 * version detail page.
 */
const ChangelogShell: React.FC<ChangelogShellProps> = ({
  header,
  toolbar,
  children,
}) => {
  return (
    <div className="h-[calc(100vh-10rem)] p-6">
      <GenericCard
        isCollapsible={false}
        className="mx-auto flex h-full max-w-6xl flex-col p-10"
      >
        <div className="flex-none">{header}</div>
        {toolbar && <div className="mt-5 flex-none">{toolbar}</div>}
        <div className="custom-scrollbar mt-6 min-h-0 flex-1 overflow-y-auto pr-1">
          {children}
        </div>
      </GenericCard>
    </div>
  );
};

export default ChangelogShell;
